var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#0D0D0D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3079 25.0908C38.0446 23.5667 36.3398 22.468 34.4263 21.9447C32.5129 21.4214 30.4839 21.499 28.6163 22.167C26.7487 22.835 25.1336 24.0607 23.9914 25.6769C22.8493 27.2931 22.2357 29.2211 22.2344 31.1975V33.8197",
    stroke: "#FF901A",
    strokeWidth: 4.92496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2991 39.3865C26.6239 40.7847 28.3396 41.7546 30.2241 42.1706C32.1086 42.5866 34.075 42.4296 35.8689 41.7198C37.6627 41.0099 39.2013 39.7801 40.2854 38.1894C41.3696 36.5988 41.9494 34.7206 41.9497 32.798V31.0522",
    stroke: "#FF901A",
    strokeWidth: 4.92496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5677 31.7123C26.5622 31.8174 26.5274 31.9195 26.4652 32.0081L22.3812 37.771C22.2685 37.9293 22.0831 38.0198 21.8886 38.0096C21.694 37.9994 21.5191 37.8901 21.4237 37.721L17.9668 31.5645C17.8666 31.3853 17.8713 31.1657 17.981 30.9915C18.09 30.8164 18.2851 30.7151 18.491 30.7259L26.0319 31.1195C26.2377 31.1303 26.4211 31.2513 26.5112 31.4368C26.5542 31.5241 26.5726 31.6192 26.5677 31.7123Z",
    fill: "#FF901A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5409 33.1749C37.5445 33.071 37.5771 32.9697 37.6369 32.8812L41.5666 27.1255C41.675 26.9674 41.8564 26.875 42.0485 26.8817C42.2406 26.8883 42.4151 26.9931 42.5122 27.1584L46.0292 33.1731C46.1312 33.3482 46.1303 33.565 46.025 33.7388C45.9205 33.9133 45.7298 34.0166 45.5266 34.0095L38.0798 33.7505C37.8765 33.7435 37.6935 33.6272 37.6014 33.4458C37.5575 33.3604 37.5376 33.2669 37.5409 33.1749Z",
    fill: "#FF901A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG2);
export default __webpack_public_path__ + "static/media/g2.fa85facd8cc5a337d4a7c2409248ec56.svg";
export { ForwardRef as ReactComponent };